import React, { ReactElement } from 'react';

import { CircularProgress } from '@mui/material';

export const ButtonLoader = (): ReactElement => {
    return <CircularProgress size='2rem' color='secondary' />;
};
